// Beta cerrada de la Huella de Carbono.
//
// La pestaña está construida y desplegada, pero todavía NO se abre a clientes: quedan
// decisiones de producto sin cerrar (a qué plan pertenece, si la carta firmada por
// proyecto se cobra aparte, el deflactor monetario) y, sobre todo, la metodología está
// pendiente del aval de la consultora. Mientras tanto se enseña solo a las cuentas de
// casa, para poder probarla contra proyectos reales en producción.
//
// ESTO NO ES UNA MEDIDA DE SEGURIDAD, es un interruptor de producto: oculta la pestaña
// y corta la ruta, pero la edge `estimate-carbon` sigue siendo invocable por cualquiera
// que tenga sesión y sea dueño del job (la protegen `requireJobOwnership` y el
// plan-guard, como al resto). No hay nada sensible detrás, solo una función que calcula
// la huella del proyecto de quien llama.
//
// POR QUÉ user_id Y NO EL CORREO: esta lista viaja dentro del bundle de JavaScript, que
// es público. Con correos, el Gmail personal de Juan quedaría ahí para cualquiera que
// mire el fuente, listo para recolectores de spam. Un uuid no dice nada de nadie.
//
// PARA ABRIRLA A TODO EL MUNDO: borrar este fichero y sus tres usos (el import y el
// `showCarbono` de Sidebar.tsx, y el `BetaHuellaGate` de App.tsx). No hay que tocar
// nada más.

/** Cuentas que ven la pestaña durante la beta cerrada (auth.users.id). */
const CUENTAS_BETA = [
  '11376938-53ad-44ca-a485-3776217356d7', // Juan, AlPlano Films
  '141a9079-dc67-4d2f-9aae-cc899621fb40', // Juan, Bastion Films (pruebas)
  '875d47e6-07b9-41eb-9e56-d32744ddac17', // Juan, cuenta personal
];

/** ¿Esta cuenta ve la Huella de Carbono? */
export function veLaHuellaDeCarbono(userId: string | null | undefined): boolean {
  if (!userId) return false;
  return CUENTAS_BETA.includes(userId);
}
